import React, { useState, useEffect } from "react";
import { CheckBoxInput } from "../../../../components/common/Buttons";
import {
  delivery_by_order_type,
  handleChangeOrdertypeGlobal,
  initialShipmentValues,
  renderTextInBlock,
  setCodAmount2,
  show_parcels,
} from "../../../../helpers/OrdersFunctionsGlobal";
import { toFixedNumber } from "../../../../helpers/Utils";
import TextInputModal from "../../../../components/common/TextInputModal";
import SelectInput from "../../../../components/common/SelectInput";
import { onChangeUseState } from "../../../../helpers/FunctionsGlobal";
import { shipment_types_options } from "../../../../helpers/GlobalOptions";
import ShipmentAdditionalServices from "../../../../components/common/GlobalModals/Orders/ShipmentAdditionalServices";
import { Input, Checkbox } from "antd";
import { localStorageShipmentBulkSetter } from "../../../../redux/Actions/orderAction";
import { useDispatch, useSelector } from "react-redux";
import SelectParcelTerminalInput from "../../../../components/globals/SelectParcelTerminalInput";
import { useCallback } from "react";
import { getOrdersShipmentsOver80Kg } from "../../../../redux/Actions/orderAction";

// cod amount
// setter
const ShipmentBuilder = ({
  supplying_ids,
  initial_pickup_address_id,
  order_rows,
  initialServices,
  order_id,
  id_order,
  additionalOptions,
  order_inf,
  order_cart_rules,
  initialAddress = {},
  initialValues = {},
}) => {
  const { pickup_addresses } = useSelector((state) => state.options);

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    packets: 1,
    weight: 1,
    cod_amount: 0,
    shipment_type: "dpd",
    delivery: "",
    carrying: false,
    cod: undefined,
    carrying: false,
  });
  // console.log({ order_rows, values });
  const [address, setAddress] = useState({});
  const [services, setServices] = useState(initialServices);
  const [pickup_address_id, set_pickup_address_id] = useState(
    initial_pickup_address_id || null
  );
  const [selectedCarrier, setSelectedCarrier] = useState("sendDirectly");
  const ordersShipmentsOver80Kg = useSelector(
    (state) => state.orders.ordersShipmentsOver80Kg
  );
  const [savedShippingAddress, setSavedShippingAddress] = useState(null);

  const countries = additionalOptions.countries;

  useEffect(() => {
    dispatch(getOrdersShipmentsOver80Kg());
  }, [dispatch]);

  useEffect(() => {
    const fetcher = async () => {
      const valuesFromHelper = initialShipmentValues(
        {
          ...order_inf,
          order_rows,
        },
        pickup_addresses
      );
      setValues((prev) => {
        const shouldPreserveCod = prev.cod !== undefined;
        const newCod = shouldPreserveCod ? prev.cod : (valuesFromHelper.general.cod || false);
        return {
          ...prev,
          shipment_type: valuesFromHelper.shipment_type,
          delivery: valuesFromHelper.delivery,
          cod: newCod,
          carrying: valuesFromHelper.general.carrying,
          weight:
            order_rows.reduce((accumulator, currentValue) => {
              if (
                typeof currentValue.product_info === "object" &&
                currentValue.product_info !== null
              ) {
                return accumulator + +currentValue.product_info.weight;
              } else {
                return accumulator + 0;
              }
            }, 0) || 1,
          ...initialValues,
        };
      });
      setAddress({ ...valuesFromHelper.address, ...initialAddress });
    };
    fetcher();
  }, [pickup_addresses.length]);

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      cod_amount: prev.cod ? codAmountInfo()?.price : 0,
    }));
  }, [order_rows.length, services, order_inf?.shipments, order_cart_rules]);

  useEffect(() => {
    localStorageDataBuilder();
  }, [values, address, services]);

  const onChangeCarrier = (carrier) => {
    if (carrier === "sendDirectly") {
      setAddress(savedShippingAddress || address);
      setSelectedCarrier(carrier);
    } else {
      setSavedShippingAddress(address);
      setSelectedCarrier(carrier);
      setAddress({
        ...ordersShipmentsOver80Kg?.[carrier],
        firstname: ordersShipmentsOver80Kg?.[carrier]?.name,
        lastname: "",
        country_id: ordersShipmentsOver80Kg?.[carrier]?.country_id,
        street: ordersShipmentsOver80Kg?.[carrier]?.address,
      });
    }
  };

  const localStorageDataBuilder = (
    old_pickup_address_id = "ignore",
    new_pickup_address_id = null
  ) => {
    if (!order_id) return;
    if (!Object.keys(address).length) return;
    const val_builder = {
      // supplier_id,
      pickup_address_id,
      values: {
        ...values,
        cod_rules: codAmountInfo(),
        shipping_price: order_inf.total_shipping_tax_incl,
      },
      address,
      order_rows: [...order_rows, ...services.filter((d) => d.selected)],
      order_row_ids: order_rows.map((d) => d.id),
      supplying_ids,
      id_order,
    };
    if (new_pickup_address_id) {
      val_builder.pickup_address_id = new_pickup_address_id;
      set_pickup_address_id(new_pickup_address_id);
    }
    dispatch(
      localStorageShipmentBulkSetter(
        order_id,
        val_builder,
        old_pickup_address_id
      )
    );
  };

  const onChange = (name, value) => {
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const delivery_options = delivery_by_order_type[values.shipment_type] || [];

  const codAmountInfo = () => {
    // For bulk actions, calculate COD based only on items being shipped
    const shippedOrderRows = [...order_rows, ...services.filter((d) => d.selected)];

    // Check for waiting payments or leasing first
    const value = setCodAmount2({
      waiting_payments: order_inf.waiting_payments,
      order_rows: shippedOrderRows,
      or_quantity_manual: {},
      shipments: order_inf.shipments,
      orderInfo: order_inf,
      order_cart_rules,
    });

    if (value.type !== "basic_cod") {
      const isCodWaitingPayment = value.type === "cod_payment_price" &&
        order_inf.waiting_payments?.some((wp) => wp.cod);

      if (!isCodWaitingPayment) {
        if (order_inf.idx == 0) return value;
        return {
          type: value.type,
          price: 0,
        };
      }
    }

    // Use setCodAmount2 result for basic_cod — it properly handles childs,
    // cart rules (checking order_cart_rule_id), and shipping price.
    // Only apply idx gating for shipping/discount on subsequent cards.
    if (order_inf.idx && order_inf.idx > 0) {
      // For non-first cards, recalculate without shipping and discount
      const rowsOnly = setCodAmount2({
        waiting_payments: [],
        order_rows: shippedOrderRows,
        or_quantity_manual: {},
        shipments: order_inf.shipments,
        orderInfo: { ...order_inf, total_shipping_tax_incl: 0, leasing_cod: null },
        order_cart_rules: [],
      });
      return {
        type: "basic_cod",
        price: toFixedNumber(rowsOnly.price),
        options: {},
      };
    }

    return value;
  };
  const orderRowsTotal = () => {
    const cod_amount_type = codAmountInfo();
    if (cod_amount_type.type == "basic_cod") {
      const shipments_additions_total = order_inf.shipments
        .filter((shipment) => {
          return (
            shipment.shipment_order_rows.length > 0 &&
            shipment.shipment_order_rows.every((d) => !d.canceled_at)
          );
        })
        .map((shipment) =>
          shipment.shipment_additional_services
            .filter((shipment_additional_service) =>
              [
                "shipping_price",
                "cod_payment_price",
                "leasing_cod",
                "basic_cod",
              ].includes(shipment_additional_service.service_key)
            )
            .map(
              (shipment_additional_service) =>
                shipment_additional_service.service_value
            )
        )
        .flat()
        .reduce((accumulator, currentValue) => +accumulator + +currentValue, 0);

      return (
        order_inf.total_price - shipments_additions_total - +values.cod_amount
      );
    } else {
      return +cod_amount_type.price - +values.cod_amount;
    }
  };

  const onChangeParcelTerminal = useCallback(
    (value) =>
      setAddress((prev) => ({
        ...prev,
        parcel_terminal_id: value,
      })),
    []
  );

  const carryingKeywords = ["Uznešanas", "kandeteenus", "užnešimas", "81", "101", "90"];
  const hasCarryingService = order_rows?.some((row) =>
    carryingKeywords.some(
      (keyword) => row.product_name?.includes(keyword)
    ) || row.childs?.some((child) =>
      carryingKeywords.some(
        (keyword) => child.product_name?.includes(keyword)
      )
    )
  );

  return (
    <div>
      <div className="row mx-2">
        <div className="col-6 pl-0 pr-1">
          <TextInputModal
            text="Packets"
            name="packets"
            value={values.packets}
            onChange={onChangeUseState(setValues)}
            warning={values.packets > 0 ? false : "Must be greater than 0"}
          />
        </div>
        <div className="col-6 pl-1 pr-0">
          <TextInputModal
            text="Weight"
            name="weight"
            value={values.weight}
            onChange={onChangeUseState(setValues)}
            warning={
              values.weight > 0 ? false : "Must be greater than or equal 0.01"
            }
          />
        </div>
        <div className="col-12 px-0">
          <SelectInput
            disabled={Object.entries(initialValues).length == 0}
            label="Supplier"
            options={additionalOptions.pickup_addresses}
            value={pickup_address_id || undefined}
            onChange={(new_pickup_address_id) => {
              localStorageDataBuilder(pickup_address_id, new_pickup_address_id);
            }}
          />
        </div>

        {services.length > 0 && (
          <div className="d-flex flex-column flex-1">
            <div className="text-xs text-black font-semi-bold pb-1 pt-2">
              Services
            </div>
            <div>
              {services.map((e, idx) => {
                return (
                  <Service
                    key={`service_${idx}`}
                    {...e}
                    idx={idx}
                    setServices={setServices}
                  />
                );
              })}
            </div>
          </div>
        )}
        <div>
          <div className="text-xs text-black font-semi-bold pb-1 pt-2">
            Delivery
          </div>
          <div className="d-flex flex-wrap minus-margin">
            {shipment_types_options.filter(
              option => !["matkahuolto", "posti"].includes(option.value)
            ).map((e) => (
              <div
                key={e.value}
                className={`d-flex align-items-center justify-content-center cursor-pointer mx-1
              ${e.value === values.shipment_type
                    ? "border-orange bg-white border"
                    : "bg-silver-light"
                  }
              `}
                style={{
                  width: "30%",
                  minHeight: 35,
                  borderRadius: 2,
                  borderWidth: 0.5,
                  marginBottom: 5,
                }}
                onClick={() => {
                  const new_type = e.value;
                  // console.log({ order });
                  const {
                    cod,
                    delivery,
                    deliveryOnSaturday,
                    delivery_same_day,
                    deliveryTime,
                    deliveryTimeHours,
                    pack,
                    sendingDocuments,
                    shipping_address_edit,
                    terminalSelected,
                    swap,
                    weight,
                    who,
                  } = handleChangeOrdertypeGlobal(
                    new_type,
                    values.shipment_type,
                    {
                      ...order_inf.shipping_address,
                      comment: address.comment,
                    },
                    {
                      ...order_inf.billing_address,
                      comment: address.comment,
                    },
                    values.cod,
                    order_inf?.carrier,
                    pickup_addresses
                  );
                  // val set
                  setValues((prev) => ({
                    ...prev,
                    cod: prev.cod,
                    deliveryOnSaturday,
                    delivery_same_day,
                    deliveryTime,
                    deliveryTimeHours,
                    pack,
                    sendingDocuments,
                    swap,
                    weight,
                    who,
                    delivery,
                    shipment_type: new_type,
                  }));
                  setAddress({
                    ...shipping_address_edit,
                    parcel_terminal_id: terminalSelected,
                  });
                }}
              >
                {renderTextInBlock(e)}
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="text-xs text-black font-semi-bold pb-1 pt-2">
            {" "}
            Shipping adress
          </div>
          <div className="d-flex flex-wrap align-items-center mb-1">
            {delivery_options.map((d) => (
              <CheckBoxInput
                key={d.label + "_" + d.value}
                text={d.label}
                checked={values.delivery == d.value}
                onChange={() => onChange("delivery", d.value)}
              />
            ))}
          </div>
          {hasCarryingService && (
            <div className="col-12 row">
              {address?.country_id === 122 && (
                <div className="col-6">
                  <CheckBoxInput
                    name={"siuntu_pilotai"}
                    text={"Siuntų pilotai"}
                    type="radio"
                    checked={selectedCarrier === "siuntu_pilotai"}
                    onChange={() => onChangeCarrier("siuntu_pilotai")}
                  />
                </div>
              )}
              {address?.country_id === 115 && (
                <div className="col-6">
                  <CheckBoxInput
                    name={"avector"}
                    text={"Avector"}
                    type="radio"
                    checked={selectedCarrier === "avector"}
                    onChange={() => onChangeCarrier("avector")}
                  />
                </div>
              )}
              {address?.country_id === 51 && (
                <div className="col-6">
                  <CheckBoxInput
                    name={"adduco"}
                    text={"Adduco"}
                    type="radio"
                    checked={selectedCarrier === "adduco"}
                    onChange={() => onChangeCarrier("adduco")}
                  />
                </div>
              )}
              <div className="col-6">
                <CheckBoxInput
                  name={"sendDirectly"}
                  text={"Siųsti tiesiogiai"}
                  type="radio"
                  checked={selectedCarrier === "sendDirectly"}
                  onChange={() => onChangeCarrier("sendDirectly")}
                />
              </div>
            </div>
          )}
          <div className="row mx-0">
            <div className="col-4 pb-1 pl-0 pr-1">
              <SelectInput
                options={countries.map((d) => ({
                  label: d.name,
                  value: d.id,
                }))}
                value={address.country_id}
                placeholder="Country"
                onChange={(country_id) => {
                  setAddress((prev) => ({
                    ...prev,
                    country_id,
                    parcel_terminal_id: null,
                  }));
                }}
              />
            </div>
            <div className="col-4 px-1 pb-1">
              <TextInputModal
                placeholder="Recipient"
                name="firstname"
                value={address.firstname}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pb-1 pl-1 pr-0">
              <TextInputModal
                placeholder="Contact person"
                name="lastname"
                value={address.lastname}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pb-1 pl-0 pr-1">
              <TextInputModal
                placeholder="Address"
                name="street"
                value={address.street}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 px-1 pb-1">
              <TextInputModal
                placeholder="City"
                name="city"
                value={address.city}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pb-1 pl-1 pr-0">
              <TextInputModal
                placeholder="Postal code"
                name="postal_code"
                value={address.postal_code}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pr-1 pl-0 pb-1">
              <TextInputModal
                placeholder="Phone"
                name="phone"
                value={address.phone}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pb-1 px-1">
              <TextInputModal
                placeholder="Email"
                name="other"
                value={address.other}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            <div className="col-4 pb-1 pl-1 pr-0">
              <TextInputModal
                placeholder="Comment"
                name="comment"
                value={address.comment}
                onChange={onChangeUseState(setAddress)}
              />
            </div>
            {show_parcels(values.shipment_type, values.delivery) && (
              <div className="col-4 px-1 pr-0 pb-1">
                <SelectParcelTerminalInput
                  value={address.parcel_terminal_id}
                  shipment_type={values.shipment_type}
                  delivery={values.delivery}
                  country_id={address.country_id}
                  onChange={onChangeParcelTerminal}
                />
              </div>
            )}
          </div>
        </div>
        <div className="w-100">
          <div className="text-xs text-black font-semi-bold pb-1 pt-2">
            Extra services
          </div>
          <ShipmentAdditionalServices
            order_rows={order_rows}
            type="bulk_action"
            order={{ id: order_id }}
            order_rows_total={orderRowsTotal()}
            order_type={values.shipment_type}
            delivery={values.delivery}
            variables={values}
            handleChangeText={(e) => {
              onChange(e.target.name, e.target.value);
            }}
            errors={{}}
            country_id={address.country_id}
            cod_details={{
              waiting_payments: order_inf.waiting_payments,
              default_cod: order_inf.leasing_cod
                ? order_inf.leasing_advance
                : order_inf.total_price || 0,
            }}
            address={address}
          />
        </div>
      </div>
    </div>
  );
};

export default ShipmentBuilder;

const Service = ({
  quantity,
  selected,
  product_name,
  unit_price_tax_incl,
  idx,
  setServices,
}) => {
  const onChange = (name, value) => {
    setServices((prev) => {
      const old_data = [...prev];
      old_data[idx][name] = value;
      return old_data;
    });
  };

  return (
    <div className="d-flex align-items-center">
      <Checkbox
        checked={selected}
        onChange={() => {
          onChange("selected", !selected);
        }}
      />
      <Input
        className="without_arrows mx-2"
        type="number"
        name="quantity"
        value={quantity}
        min={1}
        style={{
          width: 32,
          height: 32,
        }}
        onChange={(e) => {
          onChange(e.target.name, e.target.value);
        }}
      />
      <div className="text-xs text-black">
        x {product_name} - {Number(unit_price_tax_incl).toFixed(2) || 0} &#8364;
      </div>
    </div>
  );
};
